var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#332d40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m930.93 588.12h-319.05v-327.53c0-6.793-5.0898-11.879-11.879-11.879-6.793 0-11.879 5.0898-11.879 11.879v327.53h-319.05c-6.793 0-11.879 5.0898-11.879 11.879 0 3.3945 1.6914 6.793 3.3945 8.4844s5.0898 3.3945 8.4844 3.3945h319.05v327.53c0 3.3945 1.6914 6.793 3.3945 8.4844 1.6914 1.6914 5.0898 3.3945 8.4844 3.3945 6.793 0 11.879-5.0898 11.879-11.879v-327.53h319.04c6.793 0 11.879-5.0898 11.879-11.879 0.003907-6.793-5.0859-11.879-11.875-11.879z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1020 60h-840c-66.277 0-120 53.723-120 120v840c0 66.277 53.723 120 120 120h840c66.277 0 120-53.723 120-120v-840c0-66.277-53.723-120-120-120zm96 960c0 52.934-43.066 96-96 96h-840c-52.934 0-96-43.066-96-96v-840c0-52.934 43.066-96 96-96h840c52.934 0 96 43.066 96 96z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon3);
export default __webpack_public_path__ + "static/media/addIcon3.319b696e166492744a9970346d73c0e0.svg";
export { ForwardRef as ReactComponent };